"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SignUpComplete = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _MobileScreen = _interopRequireDefault(require("../MobileScreen"));

require("./index.css");

var MobileWall = function MobileWall(_ref) {
  var title = _ref.title,
      mobileScreen = _ref.mobileScreen;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  (0, _react.useEffect)(function () {
    var redirectTo = !!mobileScreen && mobileScreen.startsWith('onmail://') ? mobileScreen : t('onmail.mobile');
    setTimeout(function () {
      try {
        window.location.replace(redirectTo);
      } catch (e) {}
    }, 1500);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_MobileScreen["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col w-full h-full bg-fixed bg-cover overflow-y-auto",
    style: {
      backgroundImage: "url(".concat(t('download-onmail-bg.png'), ")")
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col flex-1 justify-center p-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "section mb-16"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "OnMail-Icon",
    src: t('download-onmail-icon.png'),
    className: "brand-icon object-contain max-w-sm h-28 mx-auto mb-4"
  }), /*#__PURE__*/_react["default"].createElement("img", {
    alt: "OnMail-Logo",
    src: t('onmail-light.png'),
    className: "brand-logo object-contain max-w-sm h-12 mx-auto"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "section content text-center text-3xl mb-16"
  }, title, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-white tracking-wide leading-tight font-light first:font-semibold"
  }, t('mobileWall.content'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "section text-center mb-16"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "inline-block shadow-lg",
    href: t('mobileWall.apple'),
    target: "_blank",
    rel: "noreferrer noopener"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "App Store",
    src: t('apple-store'),
    className: "download-item w-40"
  }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
    className: "inline-block shadow-lg",
    href: t('mobileWall.android'),
    target: "_blank",
    rel: "noreferrer noopener"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "Google Play",
    src: t('google-play'),
    className: "download-item w-40"
  })))))));
};

var SignUpComplete = function SignUpComplete() {
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_react["default"].createElement("h1", {
    className: "font-semibold text-white mb-1"
  }, t('mobileWall.signupComplete'));
};

exports.SignUpComplete = SignUpComplete;
var _default = MobileWall;
exports["default"] = _default;
//# sourceMappingURL=index.js.map